import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ModalComponent } from 'app/components/modal/modal.component';
import { ModalService } from 'app/services/modal.service';

@Component({
    selector: 'psm-delete-modal',
    templateUrl: 'deleteModal.component.html'
})

export class DeleteModalComponent extends ModalComponent<boolean> {
    public title: string = '';
    public content: string = '';

    constructor(modalService: ModalService, router: Router) {
        super(modalService, router);
    }

    public onDeleteAction() {
        this.close(true);
    }

    public onCloseClicked() {
        this.close(false);
    }

    protected onNavigation() {
        this.close(false);
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modal/deleteModal.component.ts